import { IsNotEmpty, IsDefined, Validate, ValidateNested } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { DisplayNameValidation } from 'src/core/customValidator/displayNameValidator';

export class ProductCategoryDataService extends DataService<typeof Model.Products.Logic.ViewModels.ProductCategoryItem, Model.Products.Logic.ViewModels.ProductCategoryItem, ProductCategoryItem> {
	protected map(entity: Model.Products.Logic.ViewModels.ProductCategoryItem): ProductCategoryItem {
		return new ProductCategoryItemModel(entity);
	}

	static make(ctx?: any): ProductCategoryDataService {
		return new ProductCategoryDataService(ctx, ctx => ctx.ProductCategories);
	}

	add(defaultLanguage: string): Promise<ProductCategoryItem> {
		const entity = new Model.Products.Logic.ViewModels.ProductCategoryItem();
		entity.services = [];
		(entity as any).dynamicProperties['displayName'] = {
			[defaultLanguage]: ''
		};

		return this.create(() => entity);
	}

	async getTaxonomiesForProduct(productTypes: number[], productCategoryId?: number): Promise<TaxonomicField[]> {
		const container = await this.contextService.current();
		return container.GetTaxonomiesForProduct(productTypes, productCategoryId || -1).toArray();
	}
}

export class ProductCategoryItemModel extends EntityModel<Model.Products.Logic.ViewModels.ProductCategoryItem, ProductCategoryItem> implements ProductCategoryItem {
	@property<ProductCategoryItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<ProductCategoryItemModel>(o => o.entity.productType, (o, value) => o.entity.productType = value)
	@IsNotEmpty({ message: 'Product Type is required' })
	@IsDefined({ message: 'Product Type is required' })
	public productType: number;

	@property<ProductCategoryItemModel>(o => o.entity.parentCategoryId, (o, value) => o.entity.parentCategoryId = value)
	public parentCategoryId: number;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	@Validate(DisplayNameValidation, ['en'])
	public dynamicProperties: { [prop: string]: any; };

	@property<ProductCategoryItemModel>(o => o.entity.canHaveChildrenOfType, (o, value) => o.entity.canHaveChildrenOfType = value)
	public canHaveChildrenOfType: number;

	@property<ProductCategoryItemModel>(o => o.entity.canHaveContracts, (o, value) => o.entity.canHaveContracts = value)
	public canHaveContracts: boolean;

	@property<ProductCategoryItemModel>(o => o.entity.canHaveSupplementsOrDiscounts, (o, value) => o.entity.canHaveSupplementsOrDiscounts = value)
	public canHaveSupplementsOrDiscounts: boolean;

	@property<ProductCategoryItemModel>(o => o.entity.services, (o, value) => o.entity.services = value)
	@ValidateNested()
	public services: any[];
}



// WEBPACK FOOTER //
// ./src/app/products/product-categories/form/product-category-form.data.ts